import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { Spinner } from "./Spinner";

import "./LoadingSpinner.css";

type Props = {
  className?: string;
};

export const LoadingSpinner = ({ className }: Props) => (
  <div
    className={cnTwMerge(
      "spinner-container fixed inset-0 z-[101] items-center overflow-y-auto",
      className,
    )}
    data-testid="loading-spinner"
  >
    <Spinner className="w-24 h-24" />
  </div>
);
